export const HAS_ISO8601_TIMEZONE_RE = /(Z|[+-]\d\d(:?\d\d)?)$/
